module.exports = __webpack_public_path__ + "assets/ic_tree18.0580d2e8.svg";